import { ActionName } from '../../../constants';
export var extractAutomationAction = function extractAutomationAction(response) {
  var _response$meta;
  if (!response.data) {
    return undefined;
  }
  if (!(response !== null && response !== void 0 && (_response$meta = response.meta) !== null && _response$meta !== void 0 && (_response$meta = _response$meta.supportedFeature) !== null && _response$meta !== void 0 && _response$meta.includes(ActionName.AutomationAction))) {
    return undefined;
  }
  var data = response.data;
  var meta = response.meta;
  var name = data.name,
    objectAri = data['atlassian:ari'];
  var product = meta.product,
    tenantId = meta.tenantId,
    resourceType = meta.resourceType;
  return {
    product: product,
    resourceType: resourceType,
    siteAri: "ari:cloud:".concat(product, "::site/").concat(tenantId),
    objectName: name,
    objectAri: objectAri,
    // TODO: The admin experience will be a follow up
    canManageAutomation: false,
    baseAutomationUrl: '',
    analyticsSource: 'smartCardAutomationAction'
  };
};